// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3lGCz","box":"WorkspacesBox_box__2n8he","node":"WorkspacesBox_node__3si09"};